import React, { Component } from 'react';
import HttpRunner from '../query';
import urlHandler from '../../../utils/urlHandler';
import perms from '../../../utils/permissions';
import examples from '../../../utils/examples';

class DocPositionEntity extends Component {
    constructor(props){
        super(props);

        this.state = {
            dynamicSample: false
        }
    }

    componentDidMount() {
        this.setState({
            dynamicSample: perms.checkEndpoint(urlHandler.API_ENDPOINT_V2_ENRICH)
        }) 
    }

    render() {
        return (
            <div className="bucket" id="top">
                <div>
                    <h3 className="heading-1" id='position'>Position</h3>
                    <div className="description">
                        The extraction of a entity type position is modeled around detecting titles or positions within 
                        an organization. Some examples of occurrences in a document can be seen below:
                    </div>

                    <div className="bullet-list">
                        <ul className="toc-level list-wrapper">
                            <li className="list-item">Executive Prime Minister</li>
                            <li className="list-item">Chairman of the Board </li>
                            <li className="list-item">VP of Marketing</li>
                        </ul>
                    </div>
                </div>

                <div>
                    <h4 className="heading-2">Example</h4>
                    <div className="example-content">My Company Promotes John Smith to President &amp; CEO Also appoints 
                        Joe Johnson, MD, PhD as its Chairman of the Board of Directors Marietta, GA (PRWEB) June 30, 2016 My 
                        Company, Inc., a leading manufacturer of goods, today announced that John Smith, its current Chief Operating 
                        Officer, has been named President and Chief Executive Officer. Additionally, My Company announced the 
                        appointment of Jane Doe, MD, PhD, a current My Company Director, to be the Chairman of its Board of 
                        Directors. Mr. Smith assumes the CEO position from the company founder Jane Doe, who will continue 
                        with My Company as a key part of its leadership team, as Chairman of the Executive Committee.</div>
                    <HttpRunner example="position1" 
                        query="enrich"
                        response={!this.state.dynamicSample ? JSON.stringify(examples.EXAMPLE_RESPONSE_POSITION1) : null}/>
                </div>
            </div>
        );
    }
}

export default DocPositionEntity;